import React from 'react';
import { appConfig } from '../../config';

const ChatHeader = () => {
    return (
        <>
            <span>{appConfig.headerTitle}</span>

            <img 
                src="https://www-per.instantcredito.com/WalletOnWebUser/Images/AI/IconBasic.svg" 
                alt="WDI Logo" 
                className="header-logo"
            />
        </>
    );
};

export default ChatHeader;